export default {
    install(Vue,options){
        Vue.prototype.GlobalConst = {
            customCode:'d39eaa7fc1f34190869608259133d2fb',
        };
    }
 }


// WEBPACK FOOTER //
// ./src/api/GlobalConst.js